import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { jsonToCSS } from '../../helpers/styles';
import blackStrip from './background-images/black-back-strip.png';
import stripBackground from './background-images/side-strip.png';
import speakerImg from './background-images/speaker.png';
import Led from './components/Desk/Led';
import LedSwitch from './LedSwitch';
import { colors, dimension } from './WindowConfig';

export interface IRightAnalogStripProps {}

const Container = styled.div`
  ${jsonToCSS(dimension.lowerMonitorRightStrip)};
  background-color: ${colors.analogStripBackground};
  background-image: url(${stripBackground});
`;

const IndicatorStrip = styled.div`
  width: 97%;
  height: 200px;
  background-image: url(${blackStrip});
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  padding-left: 5px;
`;

const BorderedLed = styled(Led)`
  > div {
    border: 5px double black;
    width: 24px;
    height: 24px;
    margin: 0px 3px;
  }
  margin-top: 10px;
`;

const LedRow = styled.div`
  display: flex;
  color: ${colors.white};
  width: 100%;
`;

const IndicatorText = styled.div<any>`
  display: flex;
  align-items: ${({ right }) => (right ? 'flex-start' : 'flex-end')};
  width: 50px;
  flex-direction: column;
  justify-content: center;
`;

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  & > div {
    margin-bottom: 20px;
  }
`;

const Speaker = styled.img`
  width: 160px;
  margin-left: 10px;
  margin-top: 160px;
`;

const isRed = (value: string) => {
  return value?.toLowerCase() === 'red';
};

const isGreen = (value: string) => {
  return value?.toLowerCase() === 'green';
};

export default function RightAnalogStrip(props: IRightAnalogStripProps) {
  const lowerMonitorLeds = useSelector(
    (state: any) => state.executor.s80.lowerMonitorLeds
  );
  const lowerMonitorButtons = useSelector(
    (state: any) => state.executor.s80.lowerMonitorButtons
  );
  return (
    <Container>
      <IndicatorStrip>
        <LedRow>
          <IndicatorText>
            <div>BIT</div>
            <div>FAIL</div>
          </IndicatorText>
          <BorderedLed
            ledOn={isRed(lowerMonitorLeds['bit_fail_pass'])}
            circular
            offColor={colors.rightStripRedOnColor}
            onColor={colors.rightStripRedOffColor}
          />
          <BorderedLed
            ledOn={isGreen(lowerMonitorLeds['bit_fail_pass'])}
            circular
            offColor={colors.rightStripGreenOffColor}
            onColor={colors.rightStripGreenOnColor}
          />
          <IndicatorText right>
            <div>BIT</div>
            <div>PASS</div>
          </IndicatorText>
        </LedRow>
        <LedRow>
          <IndicatorText>
            <div>UNSAFE</div>
          </IndicatorText>
          <BorderedLed
            ledOn={isRed(lowerMonitorLeds['unsafe_ovtmp'])}
            circular
            offColor={colors.rightStripRedOnColor}
            onColor={colors.rightStripRedOffColor}
          />
          <BorderedLed
            ledOn={isGreen(lowerMonitorLeds['unsafe_ovtmp'])}
            circular
            offColor={colors.rightStripGreenOffColor}
            onColor={colors.rightStripGreenOnColor}
          />
          <IndicatorText right>
            <div>OVTMP</div>
          </IndicatorText>
        </LedRow>
        <LedRow>
          <IndicatorText>
            <div>ALARM</div>
          </IndicatorText>
          <BorderedLed
            ledOn={isRed(lowerMonitorLeds['alarm_battle_short'])}
            circular
            offColor={colors.rightStripRedOnColor}
            onColor={colors.rightStripRedOffColor}
          />
          <BorderedLed
            ledOn={isGreen(lowerMonitorLeds['alarm_battle_short'])}
            circular
            offColor={colors.rightStripGreenOffColor}
            onColor={colors.rightStripGreenOnColor}
          />
          <IndicatorText right>
            <div>BATTLE</div>
            <div>SHORT</div>
          </IndicatorText>
        </LedRow>
        <LedRow>
          <IndicatorText>
            <div>CSIOS</div>
            <div>HALTED</div>
          </IndicatorText>
          <BorderedLed
            ledOn={isRed(lowerMonitorLeds['csios_halted_loaded'])}
            circular
            offColor={colors.rightStripRedOnColor}
            onColor={colors.rightStripRedOffColor}
          />
          <BorderedLed
            ledOn={isGreen(lowerMonitorLeds['csios_halted_loaded'])}
            circular
            offColor={colors.rightStripGreenOffColor}
            onColor={colors.rightStripGreenOnColor}
          />
          <IndicatorText right>
            <div>CSIOS</div>
            <div>LOADED</div>
          </IndicatorText>
        </LedRow>
      </IndicatorStrip>
      <SwitchContainer>
        <LedSwitch id="GB_bite">BITE</LedSwitch>
        <LedSwitch id="GB_system_halt">
          System <br /> HALT
        </LedSwitch>
        <LedSwitch id="GB_system_reset">
          System <br /> Reset
        </LedSwitch>
        <LedSwitch id="GB_overt_test">
          Overt <br /> Test
        </LedSwitch>
        <LedSwitch id="GB_spare"></LedSwitch>
      </SwitchContainer>
      <Speaker src={speakerImg} />
    </Container>
  );
}
